import React from "react";
import "react-vertical-timeline-component/style.min.css";
import { VerticalTimeline } from "react-vertical-timeline-component";
import ExperienceCard from "./ExperienceCard";
import lancet from "../../Assets/lancet.png";
import geeksOfGurukul from "../../Assets/geeks_of_gurukul.jpg";
import antt from "../../Assets/antt.jpg";

const MyExperience = () => {
  const experiences = [
    {
      title: "Computer Operator",
      company_name: "LANCET Diagnostic Center",
      icon: lancet,
      iconBg: "#383E56",
      date: "January 2022 - August 2022",
      points: [
        "Worked at Lancet Diagnostic Center as a Computer-Person, providing consistent contributions.",
        "Demonstrated strong professional responsibility and always delivered high-quality work.",
        "Well-liked by doctors, patients, and teammates for pleasant personality and cooperative attitude.",
        "Recognized as a conscious and motivated individual who made positive contributions to the work environment.",
      ],
    },
    {
      title: "Front-End Developer",
      company_name: "Geeks Of Gurukul",
      icon: geeksOfGurukul,
      iconBg: "#383E56",
      date: "April 2023 - September 2023",
      points: [
        "I began my professional web-dev journey as a Front-End Development intern.",
        "Developing and maintaining web applications using REACT.JS and other related technologies.",
        "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
        "Implementing responsive design and ensuring cross-browser compatibility.",
      ],
    },
    {
      title: "Full-Stack Software Engineer",
      company_name: "ANTT Robotics Ltd.",
      icon: antt,
      iconBg: "#383E56",
      date: "March 2024 - February 2025",
      points: [
        "Developing and maintaining Full-Stack Web Applications using REACT.JS and other related technologies.",
        "Making APIs using BACKEND-TECHNOLOGIES like Node.js, MongoDB, AWS.",
        "Hosting multiple projects on AWS and maintaining fast and secure access to the users.",
        "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      ],
    },
  ];
  return (
    <div id="myExperience" className="lg:pt-28 md:pt-28 pt-8">
      <div className="lg:w-[65%] md:w-[85%] mx-auto lg:px-0 md:px-0 sm:px-8 px-4">
        <div className="">
          <h4 className="text-blue text-lg font-poppins font-bold">
            MY EXPERIENCE
          </h4>
          <p className="font-poppins font-bold lg:text-xl md:text-xl mb-10">
            My experience working with many tech-giants over the years. ⏳
          </p>
        </div>
      </div>
      <>
        <div className="mt-20 flex flex-col">
          <VerticalTimeline lineColor="#1d1836">
            {experiences.map((experience, index) => (
              <ExperienceCard
                key={`experience-${index}`}
                experience={experience}
              />
            ))}
          </VerticalTimeline>
        </div>
      </>
    </div>
  );
};

export default MyExperience;
